<template>
  <div>
    <van-nav-bar title="群组信息" 
      left-arrow
      @click-left="
            $router.push({ name: 'ChannelRoomUser', params: { account: chennelId, groupname: channelDetails.channelName } })
          "         
     >
      <template #right>
        <!-- <van-icon
          style="transform: rotate(90deg);"
          name="ellipsis"
          color="#ffffff"
          size="24px"
        /> -->
      </template>
    </van-nav-bar>
    <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24" />
        </div>
      </div>
    </van-overlay>
    <div style="padding: 10px;">
        <van-row>
            <van-col v-for="(item, index) in channelUserList" :key="index" span="6" style="text-align: center;"
            @click="$router.push({ name: 'ChannelMemberDetails', params: { userId: item.account, chennelId:chennelId } })"
            >
                <img :src="item.avatar" class="imageStyle" /><br>
                <span v-if="!item.name" style="font-size:10px">{{item.account}}</span>
                <span v-else style="font-size:10px">{{item.name}}</span>
            </van-col>
            
        </van-row>
        <br>
        <van-row>
            <van-col span="24" style="text-align: center;">
                <span @click="$router.push({ name: 'ChannelMembers', params: { account: channelDetails.groupId } })">查看所有成员({{memebersCount}})</span>
            </van-col>
            
        </van-row>
    </div>
    <van-cell-group>
        <van-row>
          <van-col span="24" class="divideSection"> </van-col>
        </van-row>
        <van-cell>
            <template #title>
            <span class="custom-title">群徽:</span>
            <span style="float: right;">
             <img :src="channelDetails.avatar" class="groupImageStyle" />
            </span>
          </template>
        </van-cell>  
        <van-cell>
            <template #title>
            <span class="custom-title">名称:</span>
            <span style="float: right;">{{channelDetails.channelName}}</span>
          </template>
        </van-cell> 
        <van-cell>
            <template #title>
            <span class="custom-title">群号:</span>
            <span style="float: right;">{{channelDetails.groupId}}</span>
          </template>
        </van-cell> 
        <van-cell>
            <template #title>
            <span class="custom-title">群主:</span>
            <span style="padding-left: 80px;">{{channelDetails.ownerName}}</span>
            <span style="float: right;margin-bottom: -10px;">
                <img :src="channelDetails.ownerAvatar" class="imageStyle" />
            </span>
          </template>
        </van-cell> 
        <van-cell>
            <template #title>
            <span class="custom-title">简介:</span><br>
            <span style="font-size: 12px;color: grey;">{{channelDetails.summary}}</span>
          </template>
        </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "ChannelDetails",
  data() {
    return {
      checked:true,  
      chennelId:"",
      memebersCount: "",
      channelUserList: [],
      channelDetails: {
        avatar: "",
        groupId:"",
        channelName: "",
        summary: "",
        ownerName:"",
        ownerAvatar:""
      }, 
      loadingMask: false,
    };
  },
  computed: {},
  methods: {
    getChannelMemberList(){
        let that = this;
        that.loadingMask = true;
        let chennelId = that.chennelId;
        that
        .$wonderChat({
          url: "/api/group/" + chennelId + "?type=1",
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          that.loadingMask = false;
          let resData = res.data.dataList[0];
          let arr = resData.userList;
          that.memebersCount = arr.length;
          that.channelDetails.avatar = resData.avatar;
          that.channelDetails.groupId = res.data.dataList[0].id;
          that.channelDetails.channelName = res.data.dataList[0].name;
          that.channelDetails.summary = res.data.dataList[0].summary;
          that.channelDetails.ownerName = res.data.dataList[0].ownerName;
          that.channelDetails.ownerAvatar = res.data.dataList[0].ownerAvatar;
          that.channelUserList = arr.slice(0,8)
        });
    }, 
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
  },
  mounted: function (){
      this.isLogin();
      if(this.$route.params.account){
        this.chennelId = this.$route.params.account;
      }
      if(this.$route.params.chennelNo){
        this.chennelId = this.$route.params.chennelNo;
      }
      this.getChannelMemberList();
  }
  };
</script>

<style scoped>
.divideSection {
  height: 5px;
  background: #f1f1f1;
  border-top: 1px solid #f2f3f5;
  border-bottom: 1px solid #f2f3f5;
}

.imageStyle {
  width: 40px;
  border-radius: 25px;
}

.groupImageStyle{
  width: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/ChannelDetails.vue